import React from 'react';
import PropTypes from 'prop-types';

import { Skeleton as MUISkeleton } from '@material-ui/lab';

export const Skeleton = props => <MUISkeleton {...props} />;

Skeleton.propTypes = {
  animation: PropTypes.oneOf(['pulse', 'wave', false]),
  classes: PropTypes.object,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.object,
  variant: PropTypes.oneOf(['circle', 'circular', 'rect', 'rectangular', 'text']),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default Skeleton;
